import React, { useRef } from "react";
import "./SendBodyphoto.css";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import sendPhotoData from "./sendPhotoData";

export default function SendBodyPhoto({
  selectedImages,
  setSelectedImages,
  imgFiles,
  setImgFiles,
}) {
  
  const fileInputRefs = useRef({});

  const handleSendPhoto = (id) => {
    if (fileInputRefs.current[id]) {
      fileInputRefs.current[id].click();
    }
  };

  const handleFileInputChange = (label) => async (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      const base64Image = await blobToBase64(imageUrl);
      const formattedBase64 = formatBase64(file.name, base64Image);
      setSelectedImages((prevImages) => ({
        ...prevImages,
        [label]: formattedBase64,
      }));

      setImgFiles((prevFileStates) => ({
        ...prevFileStates,
        [label]: imageUrl,
      }));
    }
  };

  const blobToBase64 = (blobUrl) => {
    return new Promise((resolve) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = function () {
        const reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result.split(",")[1]);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", blobUrl);
      xhr.responseType = "blob";
      xhr.send();
    });
  };

  const formatBase64 = (path, base64) => {
    if (path.endsWith(".pdf") || path.endsWith(".PDF")) {
      return `data:application/pdf;base64,${base64}`;
    } else if (path.endsWith(".png") || path.endsWith(".PNG")) {
      return `data:image/png;base64,${base64}`;
    } else if (path.endsWith(".jpg") || path.endsWith(".JPG")) {
      return `data:image/jpg;base64,${base64}`;
    } else if (path.endsWith(".jpeg") || path.endsWith(".JPEG")) {
      return `data:image/jpeg;base64,${base64}`;
    } else if (path.endsWith(".mp3") || path.endsWith(".MP3")) {
      return `data:audio/mpeg;base64,${base64}`;
    }
    return base64;
  };

  return (
    <div className="sendBodyPhotoWrapper centeredFlex">
      {sendPhotoData.map((item) => (
        <div
          className="sendBodyPhotoItem centeredFlex"
          onClick={() => handleSendPhoto(item.id)}
          key={item.id}
        >
          {imgFiles[item.label] ? (
            <img
              src={selectedImages[item.label]}
              alt="uploaded"
              className="uploadedPic"
            />
          ) : (
            <div className="sendBodyPhotoField centeredFlex">
              <img src={item.img} alt="body" />
            </div>
          )}

          <div className="sendBodyPhotoHint centeredFlex">
            <div className="cameraContainer centeredFlex">
              <CameraAltIcon className="sendPhotoCameraIcon" />
            </div>
            <span>{item.text}</span>
          </div>
          <input
            type="file"
            ref={(el) => (fileInputRefs.current[item.id] = el)}
            accept="image/*"
            style={{ display: "none" }}
            onChange={handleFileInputChange(item.label)}
          />
        </div>
      ))}
    </div>
  );
}
